/* ============================================================
   stoq-rk.js — 楽天ファネル専用LP（/pages/rakuten-preorder）
   ============================================================
   1. フェーズ再判定: Liquid が埋めた data-rk-phase を、実時刻（JST）で上書きする。
      Shopify の匿名ページキャッシュで初期値が固まっても、表示が正しく切り替わるようにする。
   2. カウントダウン: 各フェーズの締切までの残り時間を表示する。
   3. 追従デュアルCTA（表示トグルのみ）。
   検証用: ?phase=a|gap|b|c|d で任意のフェーズを強制表示できる（本番は無害）。
   ※スクロールリビール（.reveal/.visible）は teaser本体と共有の stoq-pre.js が担当するため、
     本ファイルはrk固有ロジック（フェーズ・カウントダウン・追従バー）のみを持つ
     （2026-08-17 村瀬さんフィードバックでteaser CSS/JSネイティブ化・自作の .rk-reveal は撤去）。
   作成: 2026-08-06
   ============================================================ */
(function () {
  'use strict';

  /* オファー正本 rakuten-preorder-offer.md の時間軸（JST）を epoch ミリ秒で持つ */
  var T_PREORDER_END = 1788519600000; /* 2026-09-04 20:00 JST（予約廃止によりSS開始と同値＝gap/bフェーズは到達しない） */
  var T_OPEN         = 1788519600000; /* 同上（未使用・境界のみ維持） */
  var T_SS_START     = 1788519600000; /* 2026-09-04 20:00 JST スーパーSALE開始 */
  var T_SS_END       = 1789059600000; /* 2026-09-11 02:00 JST スーパーSALE終了 */
  /* 2026-10-03 追加: お買い物マラソン 2610m1（セット専用クーポン 3,000～5,000円OFF）。期間外は d に戻る */
  var T_M1_START     = 1791111600000; /* 2026-10-04 20:00 JST */
  var T_M1_END       = 1791478800000; /* 2026-10-09 02:00 JST */

  var VALID = ['a', 'gap', 'b', 'c', 'd', 'm1'];

  function phaseAt(ms) {
    if (ms < T_PREORDER_END) return 'a';
    if (ms < T_OPEN) return 'gap';
    if (ms < T_SS_START) return 'b';
    if (ms < T_SS_END) return 'c';
    if (ms >= T_M1_START && ms < T_M1_END) return 'm1';
    return 'd';
  }

  /* 各フェーズのカウントダウン先。gap / d は締切を持たない */
  function deadlineFor(phase) {
    if (phase === 'a') return T_SS_END; /* デビュー記念クーポンの終了までカウント */
    if (phase === 'b') return T_SS_START;
    if (phase === 'c') return T_SS_END;
    if (phase === 'm1') return T_M1_END;
    return null;
  }

  /* ?phase= は「実時刻のフェーズ以降」だけ強制できる（Fable P2-1）。
     過去フェーズへ戻せると、締切後に ?phase=a のURLを共有された時に
     「ご予約価格 ¥18,900・受付中」の画面が恒久的に再現できてしまう。
     制作時点（9/4以前）は全フェーズが未来なのでQAには影響しない。 */
  var forcedRaw = null;
  try {
    var q = new URLSearchParams(window.location.search).get('phase');
    if (q && VALID.indexOf(q) !== -1) forcedRaw = q;
  } catch (e) {}
  /* m1 は VALID の末尾（d より後）なので開始前のQAでは ?phase=m1 で確認できるが、
     マラソン終了後に同じURLを共有されてもクーポン表示が蘇らないよう、終了後は強制を無効にする */
  if (forcedRaw === 'm1' && Date.now() >= T_M1_END) forcedRaw = null;

  var current = null;

  function resolvePhase() {
    var real = phaseAt(Date.now());
    if (forcedRaw && VALID.indexOf(forcedRaw) >= VALID.indexOf(real)) return forcedRaw;
    return real;
  }

  /* display:none のフェーズブロック内にある teaser の .reveal は、IntersectionObserver が
     一度も交差を検知できないため opacity:0 のまま残る。フェーズが切り替わって表示された瞬間に
     中身が真っ白に見える（?phase=b 等のQAでも同じ症状）。表示するフェーズの .reveal は
     明示的に visible を付けて救済する（初期表示フェーズの分は observer が通常どおり処理する）。 */
  function revealInPhase(phase) {
    var blocks = document.querySelectorAll('.rk-p--' + phase);
    for (var i = 0; i < blocks.length; i++) {
      var els = blocks[i].querySelectorAll('.reveal');
      for (var j = 0; j < els.length; j++) els[j].classList.add('visible');
    }
  }

  function applyPhase() {
    var phase = resolvePhase();
    if (phase === current) return phase;
    current = phase;
    document.documentElement.setAttribute('data-rk-phase', phase);
    revealInPhase(phase);
    return phase;
  }

  var PAD = function (n) { return n < 10 ? '0' + n : String(n); };

  function renderCountdown() {
    var phase = applyPhase();
    var deadline = deadlineFor(phase);
    var nodes = document.querySelectorAll('[data-rk-countdown]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      /* 自分のフェーズのカウントダウンだけ動かす */
      if (el.getAttribute('data-rk-countdown') !== phase || deadline === null) {
        el.hidden = true;
        continue;
      }
      var left = deadline - Date.now();
      if (left <= 0) { el.hidden = true; continue; }
      el.hidden = false;
      var totalSec = Math.floor(left / 1000);
      var d = Math.floor(totalSec / 86400);
      var h = Math.floor((totalSec % 86400) / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;
      var set = function (key, val) {
        var t = el.querySelector('[data-cd="' + key + '"]');
        if (t) t.textContent = val;
      };
      set('d', String(d));
      set('h', PAD(h));
      set('m', PAD(m));
      set('s', PAD(s));
    }
  }

  applyPhase();
  renderCountdown();
  setInterval(renderCountdown, 1000);

  /* ---- 追従デュアルCTA（1画面分スクロールしたら出す） ---- */
  var sticky = document.getElementById('rkSticky');
  if (sticky) {
    var onScroll = function () {
      var show = window.scrollY > window.innerHeight * 0.9;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
